import * as React from "react";
import * as field from "./field";
import * as validation from "./validation/validation";
import * as styles from "../base/styles";
import { renderDropDownMenu, renderRadioGroup } from "../base/select";
import * as typestyle from 'typestyle';
import * as csstips from 'csstips';

export type DisplayValue = {display: string, value: string}
type DisplayValueSelectFieldProps = field.FieldPropsWithoutInput<DisplayValue> & { values: DisplayValue[], maxWidth?: number };
export function DisplayValueSelectField(props: DisplayValueSelectFieldProps) {
  // Add the types
  const InputField = field.Field as { new (): field.Field<DisplayValue> };

  // Add the input
  let input = (fieldProps: field.InputProps<DisplayValue>) =>
    renderDropDownMenu({
      id: fieldProps.id,
      name: fieldProps.name,
      getId: (x) => x.value,
      getText: (x) => x.display,
      value: fieldProps.value,
      values: props.values,
      onChange: fieldProps.onChange,
      error: fieldProps.error
    })
  let theInput = { input };

  return <InputField {...props} {...theInput} className={typestyle.classes(props.className, !!props.maxWidth && typestyle.style(csstips.maxWidth(140)))}/>
}

export function DisplayValueRadioSelectField(props: DisplayValueSelectFieldProps) {
  // Add the types
  const InputField = field.Field as { new (): field.Field<DisplayValue> };

  // Add the input
  let input = (fieldProps: field.InputProps<DisplayValue>) =>
    renderRadioGroup({
      id: fieldProps.id,
      name: fieldProps.name,
      getId: (x) => x.value,
      getText: (x) => x.display,
      value: fieldProps.value,
      values: props.values,
      onChange: fieldProps.onChange,
      error: fieldProps.error
    })
  let theInput = { input };

  return <InputField {...props} {...theInput} className={typestyle.classes(props.className, !!props.maxWidth && typestyle.style(csstips.maxWidth(140)))}/>
}
